export const CHECK_USERNAME = 'CHECK_USERNAME';
export const CHECK_CLIENT_COMPANY_NAME = 'CHECK_CLIENT_COMPANY_NAME';


export interface CheckUsernameAction {
	type: typeof CHECK_USERNAME;
	payload: boolean;
}

export interface CheckClientCompanyNameAction {
	payload: boolean;
	type: typeof CHECK_CLIENT_COMPANY_NAME;
}

export type RegisterAction = CheckUsernameAction|CheckClientCompanyNameAction;